module.exports = __webpack_public_path__ + "img/honor_gaoxin.9e2a6d69.png";